import React from 'react';

const BrandBanner__3 = () => {
    return (
        <div className="brand-banner--3-wrapper xmt-8 xmb-12 xmt-lg-14 xmb-lg-16">
            <div className="container banner-container">
                <a href="#">
                    <img src="./assets/sample-image/C.png" alt="aa"/>
                </a>
            </div>
        </div>
    );
};

export default BrandBanner__3;
